import React, {Component} from 'react';
import PropTypes from "prop-types";
import {BigPlayButton, ControlBar, Player, VolumeMenuButton} from 'video-react';
import play from '../../assets/play.svg';
import pause from '../../assets/pause.svg';
import revert from '../../assets/revert.svg';
import fullscreen from '../../assets/fullscreen.svg';
import playbackright from '../../assets/playbackright.svg';
import playbackleft from '../../assets/playbackleft.svg';
import revert15s from '../../assets/revert15s.svg';
import AddQuestionToFrameModal from "./FormModals/AddQuestionToFrameModal";
import api from '../../utils/api';
import VideoPlayer from '../Video/VideoPlayer';
import VideoQuestion from '../Video/VideoQuestion';
import moment from 'moment';
import ReactDropzone from "react-dropzone";
import PieChart from 'react-minimal-pie-chart';

let marks = [60, 300, 560, 700];

const sources = {
    sintelTrailer: '',
};

class VideoEdit extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isVideoUploaded: false,
            addQuestionModalIsOpen: false,
            source: '',
            attempts: 1,
            count: 0,
            done: false,
            show: false,
            showReadOnlyQuestion: false,
            frameQuestions: [],
            currentPercent: 0,
            durationVideo: 0,
            duration: 0,
            currentTime: 0,
            attemptAnswer: 0,
            globalAttemptAnswer: 0,
            player: {},
            showQuiz: false,
            showQuestion: false,
            playing: false,
            backward: false,
            left: 0,
            hoverTime: 0,
            newQuestion: null,
            videoUrl: '',
            listening: false,
            showSeek: false,
            currentModalOptionIndex: 0,
            answerAt: 0
        };
        
        this.videoContainer = React.createRef();
        this.question = React.createRef();
    }

    
    setThrowback = () => {
        let self = this;
        let question = null;
        if(this.state.frameQuestions.length > 0){
            question = JSON.parse(JSON.stringify(this.state.frameQuestions[0]));
        }
        this.setState({frameQuestions: []}, () => {
            if(self.videoContainer){
                if(question){
                    self.videoContainer.current.seekTo(question.answerAt);
                    self.question.current.hideModal();
                    setTimeout(function(){
                        self.videoContainer.current.play();
                    }, 500);
                
                }
            }
        });
 
        
                    
        
    }
    
    setThrowforward = () => {
        let self = this;
        this.setState({frameQuestions: [], count: this.state.count + 1}, () => {
            if(self.videoContainer){
                
                    
                    self.question.current.hideModal();

                        self.videoContainer.current.play();

                }
            
        });
    }



    

    handleSubmitAnswerModal = () => {
        this.setState({count: this.state.count + 1, attempts: 0, currentModalOptionIndex: 0});
        this.play();
    }

    checkModalAnswerOption = (i) => {
        this.setState({currentModalOptionIndex: i});
    }
    componentWillReceiveProps(nextProps) {
        if(this.refs.player) {
            //this.refs.player.seek(nextProps.rewindTo)
        }
    }

    //Actions
    triggerModalOpenState = () => {
        this.setState({
            addQuestionModalIsOpen: !this.state.addQuestionModalIsOpen
        })
    };

    handleStateChange(state) {
        this.setState({
            player: state
        });
        const current = Math.ceil(state.currentTime);
        let duration = state.duration;
        let currentPercent = current * 100 / duration;
        let durationVideo =
            Math.floor(duration / 60) + ':' +
            (Math.floor(duration % 60) < 10
                ? '0' + Math.floor(duration % 60)
                : Math.floor(duration % 60));
        let currentTime =
            Math.floor(current / 60) + ':' +
            (Math.floor(current % 60) < 10
                ? '0' + Math.floor(current % 60)
                : Math.floor(current % 60));
        this.setState({
            currentPercent: currentPercent,
            durationVideo: durationVideo,
            duration: duration,
            currentTime: currentTime
        });
        if(this.props.marks.length > this.state.count) {

            if (Math.ceil(this.state.player.currentTime) === this.props.marks[this.state.count].time) {

                this.pause();
                this.setState({
                    show: true,
                    showQuestion: true
                });
            }
        }

        if (Math.ceil(this.state.player.currentTime) === Math.ceil(duration)) {
            this.setState({
                showQuiz: true
            })
        }
    }

    answerSuccess = () => {
        this.setState({
            count: this.state.count+1,
            showQuestion: false
        });

        // Continue video
        this.play();
    }

    play = () => {
        this.refs.player.play();
        this.setState({
            playing: true
        })
    };

    pause = () => {
        this.refs.player.pause();
        this.setState({
            playing: false
        })
    };

    changeCurrentTime = (seconds) => {
        return () => {
            const {player} = this.refs.player.getState();
            const currentTime = player.currentTime;

                if (currentTime - seconds < this.props.marks[this.state.count - 1].time) {
                    if (this.state.count - 1 === 0) {
                        this.refs.player.seek(0);
                    } else {
                        this.refs.player.seek(this.props.marks[this.state.count - 1].time);
                    }
                    this.setState({count: (this.state.count - 1)});
                } else {
                    this.refs.player.seek(seconds);
                }

        };
    };

    seek = (seconds) => {
        return () => {
            this.refs.player.seek(seconds);
        };
    };

    changePlaybackRateRate = (steps) => {
        if (this.state.playing) {
            return () => {
                const {player} = this.refs.player.getState();
                const playbackRate = player.playbackRate;
                if (this.refs.player.playbackRate > 0) {
                    this.refs.player.playbackRate = playbackRate + steps;
                }
            };
        } else {
            return null
        }
    };

    setMuted = (muted) => {
        return () => {
            this.refs.player.muted = muted;
        };
    };

    setFullScreen = () => {
        this.refs.player.toggleFullscreen();
    };

    setBackward = () => {
        if (this.state.count-1 === 0){
            this.refs.player.seek(0);
        } else {
            if (!this.state.backward){
                this.refs.player.seek(this.props.marks[this.state.count - 1].time);
                this.setState({backward: true})
            } else {
                this.refs.player.seek(this.props.marks[this.state.count - 2].time);
                this.setState({backward: false})
            }
            this.setState({count: (this.state.count - 1)});
        }
    };

    onMouseMove = (e) => {
        let el = document.getElementsByClassName('wrap-progress-yt')[0].offsetWidth;
        let mouseX = e.nativeEvent.offsetX;
        let hoverSeconds = (this.state.duration * mouseX / el < 1)
            ? 0
            : this.state.duration * mouseX / el;

        let remainingSeconds = (Math.floor(hoverSeconds % 60) < 10) ? "0" + Math.floor(hoverSeconds % 60).toString() : Math.floor(hoverSeconds % 60);
        let hoverTime = Math.floor(hoverSeconds / 60) + ':' + remainingSeconds;
        this.setState({
            left: mouseX,
            hoverTime: hoverTime
        });
    };

    onSeekVideo = (e) => {
        let el = document.getElementsByClassName('wrap-progress-yt')[0].offsetWidth;
        let mouseX = e.nativeEvent.offsetX;
        let hoverSeconds = (this.state.duration * mouseX / el < 1)
            ? 0
            : this.state.duration * mouseX / el;

        let percent = Math.ceil((mouseX - el.left) / e.target.offsetWidth * 100);
        let seconds = Math.ceil(this.state.duration * (percent / 100));
        this.refs.player.seek(hoverSeconds);

    }



    renderModal = () => {
        return this.props.chapterVideo.VideoQuestions.map((item, index) => {
            if (index === this.state.count) {
                return (
                    <div
                        key={index}
                        className="modal fade in"
                        id="MCQChallange"
                        tabIndex="-1"
                        role="dialog"
                        aria-labelledby="myModalLabel"
                        style={{display: 'block'}}
                    >
                        <div
                            // className="modal-dialog"
                            className={`modal-dialog ${this.state.isFullscreen && 'fullscreen_modal'}`}
                            role="document"
                        >
                            <div className="modal-content">
                                {/*<div className="timer">*/}
                                {/*<h1>36:06</h1>*/}
                                {/*</div>*/}
                                <div className="modal-header">
                                    <button
                                        type="button"
                                        className="close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                    <h4
                                        className="modal-title"
                                        id="myModalLabel">
                                        Challenge Question
                                    </h4>
                                </div>
                                <div className="modal-body">
                                    <div className="final_quiz_list">
                                        <div
                                            className="question sp-20 active-question"
                                            id="FinalQuizQuestion3"
                                        >
                                            <p className="font-18">
                                                {item.question}
                                                {this.props.marks[this.state.count].audioUrl &&
                                                <audio autoplay controls>
                                                    <source src={api.makeFileURL(this.props.marks[this.state.count].audioUrl, this.props.user.id)} type="audio/webm" />
                                                </audio>
                                                }
                                            </p>
                                            <ul className="list-unstyled mcqList">
                                                <li>
                                                    <label>
                                                        <div
                                                            className={`iradio_square video-modal-radio-wrapper ${this.state.currentModalOptionIndex === 1 && 'checked'}`}
                                                        >
                                                            <input
                                                                type="radio"
                                                                name="radio"
                                                                value="60"
                                                                className='video-modal-radio'
                                                                onClick={()=>this.checkModalAnswerOption(1)}
                                                            />
                                                            <ins className="iCheck-helper video-modal-radio-icon"/>
                                                        </div>
                                                        {item.optionA}
                                                    </label>
                                                </li>
                                                <li>
                                                    <label>
                                                        <div
                                                            className={`iradio_square video-modal-radio-wrapper ${this.state.currentModalOptionIndex === 2 && 'checked'}`}
                                                            // aria-checked="false"
                                                            // aria-disabled="false"
                                                        >
                                                            <input
                                                                type="radio" name="radio" value="60"
                                                                className='video-modal-radio'
                                                                onClick={(e)=>this.checkModalAnswerOption(2)}
                                                            />
                                                            <ins
                                                                className="iCheck-helper video-modal-radio-icon"
                                                            />
                                                        </div>
                                                        {item.optionB}
                                                    </label>
                                                </li>
                                                <li>
                                                    <label>
                                                        <div
                                                            // className="iradio_square video-modal-radio-wrapper"
                                                            className={`iradio_square video-modal-radio-wrapper ${this.state.currentModalOptionIndex === 3 && 'checked'}`}
                                                            aria-checked="false"
                                                            aria-disabled="false"
                                                        >
                                                            <input
                                                                type="radio"
                                                                name="radio"
                                                                value="60"
                                                                className='video-modal-radio'
                                                                onClick={(e) => this.checkModalAnswerOption(3)}
                                                            />
                                                            <ins className="iCheck-helper video-modal-radio-icon"/>
                                                        </div>
                                                        {item.optionC}
                                                    </label>
                                                </li>
                                                <li>
                                                    <label>
                                                        <div
                                                            className={`iradio_square video-modal-radio-wrapper ${this.state.currentModalOptionIndex === 4 && 'checked'}`}
                                                        >
                                                            <input
                                                                type="radio"
                                                                name="radio"
                                                                value="60"
                                                                className='video-modal-radio'
                                                                onClick={()=>this.checkModalAnswerOption(4)}
                                                            />
                                                            <ins className="iCheck-helper video-modal-radio-icon"/>
                                                        </div>
                                                        {item.optionD}
                                                    </label>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <div className="row">
                                        <div className="col-xs-6">
                                            {this.state.showSeek == false ?
                                                <div className="final-mcqs-controls">
                                                    <a
                                                        href="#"
                                                        className="btn btn-default"
                                                        onClick={() => this.handleSubmitAnswerModal()}
                                                    >
                                                        Skip Question
                                                    </a>

                                                    <button
                                                        className="btn btn-primary"
                                                        onClick={(e) => this.handleSubmitAnswerModal()}
                                                    >
                                                        Submit Answer
                                                    </button>
                                                </div>

                                                :

                                                <div className="final-mcqs-controls">
                                                    <a
                                                        href="#"
                                                        className="btn btn-default"
                                                        onClick={this.handleSkipQuestionModal}
                                                    >
                                                        Skip Question
                                                    </a>
                                                    <button
                                                        className="btn btn-primary"
                                                        onClick={(e) => this.changeCurrentTime(item.answerAt)}
                                                    >
                                                        Seek to Answer
                                                    </button>
                                                </div>
                                            }
                                        </div>

                                        <div className="col-xs-6">
                                            <div className="paginationFinalQuiz text-right">
                                                {index + 1}/{this.props.chapterVideo.VideoQuestions.length}
                                            </div>
                                        </div>
                                    </div>
                                    {/*<div*/}
                                    {/*className="alert alert-info sm-bottom0 sm-top20"*/}
                                    {/*// style="display: none;"*/}
                                    {/*id="AlertNoGuessWorkPlease"*/}
                                    {/*>*/}
                                    {/*<p>*/}
                                    {/*We just want to confirm that you are not doing a guess work.*/}
                                    {/*<a href="#">*/}
                                    {/*Yes Thats Correct!*/}
                                    {/*</a>*/}
                                    {/*</p>*/}
                                    {/*</div>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        })
    };

    //Renders
    renderVideo = () => (
        <div className="panel customPanel">
            <div className="panel-body">
                <div>
                    {this.state.showQuestion ?
                        this.renderModal()
                    : null}
                    {this.state.source ?
                        <Player
                            ref="player"

                        >
                            <source src={this.state.source}/>
                            <ControlBar disableDefaultControls={true}/>
                            <BigPlayButton disabled/>
                            <VolumeMenuButton vertical={true}/>
                        </Player>
                        :
                        null
                    }
                </div>
                <div
                    className="wrap-yt"
                    style={{display: this.state.show ? "flex" : ''}}

                >
                    <div className="yt-progress-bar"

                    >
                        <div
                            className="wrap-progress-yt"
                            onMouseMove={this.onMouseMove}
                            onMouseUp={(e) => this.onSeekVideo(e)}




                        >
                            <div
                                className="mouse-hover-time"
                                style={{left: `${this.state.left+'px'}`}}
                            >
                                {this.state.hoverTime}
                            </div>
                            {this.renderMarks()}
                            <div
                                className='video-progress-pin'
                                style={{
                                    left: `${this.state.currentPercent < 99
                                        ? this.state.currentPercent + '%'
                                        : '99%'}`
                                }}

                            />
                            <div className="progress-video-yt"
                                 role="progressbar"
                                 aria-valuenow={this.state.currentPercent}
                                 aria-valuemin="0"
                                 aria-valuemax="100"
                                 style={{
                                     width: `${this.state.currentPercent < 99
                                         ? this.state.currentPercent + '%'
                                         : '99%'}`
                                 }}
                            >
                            </div>
                        </div>
                        <span className="yt-time">{this.state.durationVideo}</span>
                    </div>
                    <div className="yt-controls-btn">
                        <div className="wrap-yt-btn btn-play-pause">
                            {
                                !this.state.playing &&
                                <button
                                    className="btn-player"
                                    onClick={this.play}
                                >
                                    <img
                                        src={play}
                                        alt="play"
                                    />
                                </button>
                            }
                            {
                                this.state.playing &&
                                <button
                                    className="btn-player"
                                    onClick={this.pause}
                                >
                                    <img
                                        src={pause}
                                        alt="pause"
                                    />
                                </button>
                            }
                        </div>
                        <div className="wrap-yt-btn">
                            <button
                                className="btn-player"
                                onClick={this.setBackward}
                            >
                                <img
                                    src={revert}
                                    alt="revert"
                                />
                            </button>
                            <button
                                className="btn-player"
                                onClick={this.changeCurrentTime(15)}
                            >
                                <img
                                    src={revert15s}
                                    alt="revert 15 seconds"
                                />
                            </button>
                            <button
                                className="btn-player"
                                onClick={
                                    this.changePlaybackRateRate(-0.5)
                                }
                            >
                                <img
                                    src={playbackleft}
                                    alt="playback"
                                />
                            </button>
                            <button
                                className="btn-player"
                                onClick={this.changePlaybackRateRate(0.5)}
                            >
                                <img
                                    src={playbackright}
                                    alt="playback"
                                />
                            </button>
                            <button
                                className="btn-player"
                                onClick={this.setFullScreen}
                            >
                                <img
                                    src={fullscreen}
                                    alt="full screen"
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    renderMarks = () => {
        return this.props.marks.map((item, index) => (
            <span
                key={index}
                className='video-mark-style'
                style={{left: `${item.time * 100 / this.state.duration + '%'}`}}
            />
        ))
    };

    renderTempVideo = (file) =>{

        var reader = new FileReader();
        let self = this;

        reader.onload = function(event){
            self.setState({source: event.target.result})
        }

        reader.readAsDataURL(file);
    }

    uploadVideo = (e) => {
        const data = new FormData();

        let myVideos = [];
        var files = e.target.files;
        myVideos.push(files[0]);
        var video = document.createElement('video');
        video.preload = 'metadata';
        let self = this;
        
        video.onloadedmetadata = function() {
            window.URL.revokeObjectURL(video.src);
            var duration = video.duration;
            myVideos[myVideos.length - 1].duration = duration;
            
            data.append('file', files[0], self.props.chapterVideo.id + "-" + new Date().getTime().toString() + "-" + files[0].name);

            self.renderTempVideo(files[0]);

            if(self.props.chapterVideo.id){
                
                self.props.uploadVideo(data, self.props.chapterVideo.id, duration, self.props.user.id);

                //this.props.onUpdateVideo(this.props.video);
            }else{
                const lecture = {
                    title: '',
                    description: '',
                    notes: '',
                    finish: 0,
                    status: 'Active',
                    feedbackPrompt: '',
                    number: self.props.number,
                    subjectId: self.props.subjectId,
                    subjectChapterId: self.props.chapterId,
                    courseId: self.props.courseId
                    
                }
                self.props.uploadVideoCreate(data, lecture, duration, self.props.user.id);
            }
            
            
        }
        
        video.src = URL.createObjectURL(files[0]);
          
        


    }

    uploadSubtitles = (e) => {
        const data = new FormData();
        data.append('file', e.target.files[0], this.props.video.id + "-" + new Date().getTime().toString() + "-" + e.target.files[0].name);

        //this.renderTempVideo(e.target.files[0]);
        this.props.uploadSubtitles(data, this.props.video.id, this.props.user.id);
    }

    onDrop = (files) => {
        const data = new FormData();

        this.renderTempVideo(files[0]);
        let myVideos = [];

        myVideos.push(files[0]);
        var video = document.createElement('video');
        video.preload = 'metadata';
        let self = this;
        
        video.onloadedmetadata = function() {
            window.URL.revokeObjectURL(video.src);
            var duration = video.duration;
            myVideos[myVideos.length - 1].duration = duration;            
            data.append('file', files[0], self.props.chapterVideo.id + "-" + new Date().getTime().toString() + "-" +files[0].name);
            self.renderTempVideo(files[0]);

            if(self.props.chapterVideo.id){
                
                self.props.uploadVideo(data, self.props.chapterVideo.id, duration, self.props.user.id);

                //this.props.onUpdateVideo(this.props.video);
            }else{
                const lecture = {
                    title: '',
                    description: '',
                    notes: '',
                    finish: 0,
                    status: 'Active',
                    feedbackPrompt: '',
                    number: self.props.number,
                    subjectId: self.props.subjectId,
                    subjectChapterId: self.props.chapterId,
                    courseId: self.props.courseId
                    
                }
                self.props.uploadVideoCreate(data, lecture, duration, self.props.user.id);
            }
            
            
        }
        
        video.src = URL.createObjectURL(files[0]);
    }

    renderInitialUploadVideoBlock = () => (

        <div className="sp-20 video-upload-controls initial-upload">
            <ReactDropzone
                onDrop={this.onDrop}
                className="initial-upload-block"
                accept='video/*'
                
                >
                <i className="zmdi zmdi-cloud-upload" />
                
                </ReactDropzone>

           
        </div>
    );

    renderUploadVideoBlock = () => (
        <div
            className="bg-white">
            <div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="sp-20 video-upload-controls">
        
                            <form>
                                <div
                                    className="fileinput fileinput-new"
                                    data-provides="fileinput"
                                >
                                    {this.props.video.subtitles &&
                                        <div className="sp-20">
                                        <a href={api.makeFileURL(this.props.video.subtitles, this.props.user.id)} target="_blank">
                                            View Subtitles
                                        </a>
                                        </div>
                                    }
        
        
                                    <span className="btn btn-default btn-file">
                                                <span className="fileinput-new">
                                                    <i className="zmdi zmdi-upload"/> &nbsp;
                                                    Upload Subtitles
                                                </span>
                                                <input
                                                    type="file"
                                                    accept=".vtt"
                                                    onChange={this.uploadSubtitles}
                                                />
                                            </span> &nbsp;
        
                                            <span className="btn btn-default btn-file">
                                                <span className="fileinput-new">
                                                    <i className="zmdi zmdi-upload"/> &nbsp;
                                                    Upload New Video
                                                </span>
                                                {
                                                    this.state.isVideoUploaded &&
                                                    <span className="fileinput-exists">
                                                        Change
                                                    </span>
                                                }
                                                <input
                                                    type="file"
                                                    onChange={this.uploadVideo}
                                                />
                                            </span>
                                    <span className="fileinput-filename"/>
                                    &nbsp;
                                    <a
                                        className="close fileinput-exists"
                                        data-dismiss="fileinput"
                                    />
        
                                    {this.props.chapterVideo.VideoFile && this.props.chapterVideo.VideoFile.length > 0 &&
                                        <button className="btn btn-primary text-white"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                this.props.deleteVideo(this.props.video, this.props.user.id)
                                            }}
                                        >
                                            <i className="zmdi zmdi-delete" /> &nbsp;
                                            Remove This Video
                                        </button>
                                    }
                                </div>
        
                            </form>
                        </div>
                    </div>
                    <div className="col-md-6">
                        {this.props.chapterVideo.VideoFile ? 
                            this.props.chapterVideo.VideoFile.length > 0 ?
                                this.renderAddQuestionBlock()
                            : null
                         : null
                        }    
                    </div>
                </div>
            </div>
        </div>
    );
    
    renderAnswer = () => {
        let answer = '';
        let minutes = String(moment.duration(this.state.answerAt*1000).minutes());
        let seconds = String(moment.duration(this.state.answerAt*1000).seconds());
        
        if(minutes.length === 1){
            minutes = "0" + minutes;
        }
        
        if(seconds.length === 1){
            seconds = "0" + seconds;
        }
        
        answer = minutes + ":" + seconds;
        
        return answer
            
    }

    renderAddQuestionBlock = () => (
        <div className="sp-20 video-upload-controls text-right">

                    <div className="form-group">
                        <input
                            type="text"
                            className="form-control"
                            value={this.state.currentTime}
                            style={{height: 'initial', display: "inline-block", width: '70px', marginRight: '10px'}}
                        />
                    
                        <button
                            onClick={(e) => {
                                
                                this.setState({
                                    answerAt: this.videoContainer.current.state.currentSeconds
                                });

                            }}
                            className={`btn ${this.state.answerAt ? 'btn-primary' : 'btn-default'}`}>
                            {this.state.answerAt ? 'Answer at ' + this.renderAnswer() : 'Key Answer'}
                        </button> &nbsp;
                        
                        <button
                            onClick={(e) => {
                                const currentTime = this.videoContainer.current.state.currentSeconds;
                                let newQuestion =  {
                                        time: Math.ceil(currentTime),
                                        question: "",
                                        answer: "",
                                        answerAt: this.state.answerAt,
                                        attempts: 0,
                                        completed: false,
                                        tag: 'MCQ'
                                    };

                                this.setState({
                                    newQuestion: newQuestion
                                });

                                this.triggerModalOpenState();
                            }}
                            className="btn btn-default">
                            Add Question
                        </button>
                    </div>

        </div>
    );
    
    showVideoQuestion = (frameQuestions) => {
        
        if(JSON.stringify(frameQuestions) !== JSON.stringify(this.state.frameQuestions)){
            this.setState({
                show: true,
                showQuestion: true,
                showReadOnlyQuestion: false,
                frameQuestions: frameQuestions
            });
        }
    }
    
    onVideoComplete = () => {
        
    }

    renderProgress = () => {
        return (
            <div className="video-upload-progress">
                <PieChart
                    style={{width: 300, margin: '0 auto'}}
                    data={[
                        {value: 100, color: '#555'},
                        {value: (this.props.uploadProgress) ? this.props.uploadProgress : 0, color: '#e33339'}
                    ]}
                    totalValue={100}
                    startAngle={-90}
                    lineWidth={2}
                    rounded={true}
                />
                <p className="diagnostic-pie-chart-counter chart-tile video-progress-text">{this.props.uploadProgress === 100 ? 'Processing...' : this.props.uploadProgress.toString() + '%'}</p>
            </div>
        )
    }

    render() {
        return (
            <div className="col-sm-12">
                {
                    this.state.addQuestionModalIsOpen &&
                    <AddQuestionToFrameModal
                        triggerModalOpenState={this.triggerModalOpenState}
                        question={this.state.newQuestion}
                        user={this.props.user}
                        onSave={(data) => this.props.saveVideoQuestion(data, this.props.user.id)}
                    />
                }

                {this.props.hasLecture ?
                <div>
                    {this.props.chapterVideo.id &&
                        <section>
                            {this.props.chapterVideo.id &&
                            <div className="container">
                                <div className="row">
                                    
                                    <div className="col-sm-12">
            
                                        <VideoQuestion
                                            ref={this.question}
                                            totalQuestions={this.props.chapterVideo.VideoQuestions ? this.props.chapterVideo.VideoQuestions.length : 0}
                                            isFullscreen={this.state.isFullscreen}
                                            frameQuestions={this.state.frameQuestions}
                                            setThrowforward={this.setThrowforward}
                                            setThrowback={this.setThrowback}
                                            updateVideoQuestion={(question, token) => this.updateVideoQuestion(question, token)}
                                            videoQuestions={this.props.videoQuestions}
                                            user={this.props.user}
                                            onFinish={() => this.onVideoComplete()}
                                            embedded={true}
                                            qi={this.state.count + 1}
                                        />
                                        
                                        {this.props.chapterVideo.VideoFile ? 
                                            this.props.chapterVideo.VideoFile.length > 0 ?
                                        <VideoPlayer
                                            ref={this.videoContainer}
                                            videoFile={this.props.chapterVideo.VideoFile ? this.props.chapterVideo.VideoFile[0] : null}
                                            courseUser={null}
                                            profile={this.props.profile}
                                            userVideoQuestions={this.props.videoQuestions ? this.props.videoQuestions : []}
                                            fullVideoQuestions={this.props.chapterVideo.VideoQuestions ? this.props.chapterVideo.VideoQuestions : []}
                                            marks={[]}
                                            completed={false}
                                            onFinish={() => this.onVideoComplete()}
                                            showVideoQuestion={(frameQuestions) => this.showVideoQuestion(frameQuestions)}
                                            user={this.props.user}
                                            chapterPart={this.props.chapterVideo}
                                            count={this.state.count}
                                            embedded={true}
                                            updateCurrentTime={t => this.setState({currentTime: t})}
                                            userLecture={{}}
                                        />
                                        : null
                                        : null
                                        }
                                    </div>
    
                                </div>
                            </div>
                            }
                        </section>
                    }


                    {this.props.uploadProgress > 0 &&
                        this.renderProgress()
                    }


                    {/*
                    <div className="panel customPanel">
                        <div className="panel-body">
                            <div>
                                <div className="progress-count text-right">
                                    {this.props.uploadProgress}%
                                </div>
                                <div className="progress-bar-container">
                                    <div className="progress-bar" style={{width: this.props.uploadProgress + "%"}}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    */}
                    
                </div>

                :

                null }

                {this.props.hasLecture ?
                <div className="row sm-bottom20" id="player">
                    <div className="">
                        {this.renderUploadVideoBlock()}
                    </div>
                    
                </div>

                : this.renderInitialUploadVideoBlock()}
            </div>
        );
    }
}

VideoEdit.propTypes = {
    rewindTo: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
};

export default VideoEdit;


// WEBPACK FOOTER //
// ./src/components/EditChapterPart/VideoEdit.js